import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { WrapperComponentDirective } from '@rd-lib/whitelabel/wrapper/wrapper.component';
import { AuthRenderState, LoyaltyCurrency, PointsSummary } from '@rd/types';

@Component({
  selector: 'rd-core-main-header-wrapper',
  template: '<ng-container #viewChild></ng-container>',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HeaderWrapperComponent extends WrapperComponentDirective {
  @Input() authRenderState: AuthRenderState;
  @Input() pointsSummary: PointsSummary;
  @Input() loyaltyCurrencySelected: LoyaltyCurrency;
  @Output() toggleSideNav: EventEmitter<void> = new EventEmitter<void>();
  @Output() logoutEvent: EventEmitter<void> = new EventEmitter<void>();

  componentName = 'core-header';
}
